import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { COMPANY_SHORT_NAME, PRODUCT_TAGLINE, SUPPORT_EMAIL, copyrightYear } from "../lib/brand";
import CompanyLink from "./CompanyLink";

// The same footer on every page, signed-in or not. The legal entity and postal
// address are deliberately not here: they appear only in the body of the Terms
// and Privacy pages, which the footer links to.
export default function Footer() {
  return (
    <footer className="mt-16 border-t border-slate-200 bg-surface">
      {/* Extra room at the bottom on a phone, where our chat bubble floats
          over the bottom right corner and would otherwise sit on the links. */}
      <div className="mx-auto grid max-w-6xl gap-8 px-4 pb-28 pt-10 sm:grid-cols-2 sm:pb-10">
        <div>
          <Logo />
          <p className="mt-3 text-sm text-slate-500">{PRODUCT_TAGLINE}</p>
          <p className="mt-4 text-xs text-slate-500">
            A <CompanyLink /> product.
          </p>
        </div>

        <div className="text-xs text-slate-500 sm:text-right">
          {/* Each link is padded to about 40px tall, so it can be tapped on
              a phone; the spacing reads the same. */}
          <p className="-mt-3 space-x-2">
            <Link className="inline-block py-3 hover:text-slate-900" to="/compare">
              Compare
            </Link>
            <span aria-hidden="true">·</span>
            <Link className="inline-block py-3 hover:text-slate-900" to="/terms">
              Terms of Use
            </Link>
            <span aria-hidden="true">·</span>
            <Link className="inline-block py-3 hover:text-slate-900" to="/privacy">
              Privacy Policy
            </Link>
            <span aria-hidden="true">·</span>
            <a className="inline-block py-3 hover:text-slate-900" href={`mailto:${SUPPORT_EMAIL}`}>
              Contact
            </a>
          </p>
          <p>
            © {copyrightYear()} {COMPANY_SHORT_NAME}. All rights reserved.
          </p>
        </div>
      </div>
    </footer>
  );
}
